<div class="assay-workbook-export-renderer">
  <app-assay-summary [tableId]="summaryTableId" [exportMode]="true"></app-assay-summary>
  <app-assay-details-failures
    [tableId]="detailsTableId"
    [exportMode]="true"></app-assay-details-failures>
</div>
